import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { InfoIconComponent } from '@components/info-icon/info-icon.component';

type InputClassValue =
  | string
  | string[]
  | Set<string>
  | { [klass: string]: boolean };

@Component({
  selector: 'app-password-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InfoIconComponent],
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss']
})
export class PasswordInputComponent implements OnChanges {
  @Input() control: AbstractControl | null = null;
  @Input() label = '';
  @Input() required = false;
  @Input() infoMessage = '';
  @Input() inputId = '';
  @Input() name = '';
  @Input() placeholder = '';
  @Input() autocomplete = 'off';
  @Input() maxLength: number | null = null;
  @Input() inputClass: InputClassValue = '';

  @Output() keypressEvent = new EventEmitter<KeyboardEvent>();
  @Output() keydownEvent = new EventEmitter<KeyboardEvent>();
  @Output() blurEvent = new EventEmitter<FocusEvent>();
  @Output() focusEvent = new EventEmitter<FocusEvent>();
  @Output() pasteEvent = new EventEmitter<ClipboardEvent>();

  isPasswordVisible = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['control'] && !this.control?.value) {
      this.isPasswordVisible = false;
    }
  }

  get inputType(): string {
    return this.isPasswordVisible ? 'text' : 'password';
  }

  get labelText(): string {
    return `${this.label}${this.required ? '*' : ''}`;
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
}
